import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Download } from "lucide-react";

export default function Reports() {
  const [branches, setBranches] = useState([]);
  const now = new Date();
  const [month, setMonth] = useState(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`);
  const [branch, setBranch] = useState("all");
  const [from, setFrom] = useState(""); const [to, setTo] = useState("");
  useEffect(() => { api.get("/branches").then(({ data }) => setBranches(data)); }, []);

  const download = async (endpoint, params, filename) => {
    const res = await api.get(endpoint, { params, responseType: "blob" });
    const url = URL.createObjectURL(res.data); const a = document.createElement("a");
    a.href = url; a.download = filename; a.click();
  };

  return <div className="space-y-8" data-testid="reports-page">
    <div><div className="overline">Reports</div><h1 className="font-serif text-4xl mt-1">Reports</h1></div>
    <div className="grid md:grid-cols-2 gap-6">
      <div className="kpi-card space-y-4">
        <div><h2 className="font-serif text-2xl">Monthly Branch Report</h2><p className="text-sm text-muted-foreground">Opening balance, activity and closing outstanding per branch.</p></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Month</Label><Input type="month" value={month} onChange={e => setMonth(e.target.value)} data-testid="rep-month" /></div>
          <div><Label>Branch</Label><Select value={branch} onValueChange={setBranch}><SelectTrigger data-testid="rep-branch"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">All Branches</SelectItem>{branches.map(b => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent></Select></div>
        </div>
        <Button className="gold-bg" onClick={() => download("/reports/branch-monthly", { month, branch }, `branch_monthly_${month}.xlsx`)} data-testid="download-branch-report"><Download className="w-4 h-4 mr-2" />Download Excel</Button>
      </div>
      <div className="kpi-card space-y-4">
        <div><h2 className="font-serif text-2xl">Employee Level Report</h2><p className="text-sm text-muted-foreground">Per-employee opening → closing outstanding with activity totals.</p></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Month (optional)</Label><Input type="month" value={month} onChange={e => setMonth(e.target.value)} data-testid="rep-emp-month" /></div>
          <div><Label>Branch</Label><Select value={branch} onValueChange={setBranch}><SelectTrigger data-testid="rep-emp-branch"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">All Branches</SelectItem>{branches.map(b => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent></Select></div>
          <div><Label>Date From</Label><Input type="date" value={from} onChange={e => setFrom(e.target.value)} data-testid="rep-emp-from" /></div>
          <div><Label>Date To</Label><Input type="date" value={to} onChange={e => setTo(e.target.value)} data-testid="rep-emp-to" /></div>
        </div>
        <Button className="gold-bg" onClick={() => download("/reports/employee-level", { month: from || to ? undefined : month, branch, date_from: from || undefined, date_to: to || undefined }, `employee_report.xlsx`)} data-testid="download-emp-report"><Download className="w-4 h-4 mr-2" />Download Excel</Button>
      </div>
    </div>
  </div>;
}
